export const TestIds = {
  noReviewsPlaceholder: 'no-reviews-placeholder-test-id',
  ratingValue: 'rating-value-test-id',
  ratingIcons: 'rating-icons-test-id',
  splitIcon: 'split-icon-test-id',
  reviewsCounter: 'reviews-counter-test-id',
  srOnly: 'sr-only-test-id',
} as const;

export const NoReviewsMode = {
  NOTHING: 'nothing',
  EMPTY_ICONS: 'emptyIcons',
  PLACEHOLDER_TEXT: 'placeholderText',
};

export const DEFAULT_SHAPE_SIZE = 25;
export const DEFAULT_SHAPE_SPACING = 8;

const TranslationNamespace = 'Accessibility';

export const defaultLabels = {
  a11yAverage: 'average rating is',
  a11yOutOf: 'out of 5',
  a11yBasedOn: 'based on',
  a11yVotes: 'votes',
  a11yNoVotes: 'No ratings yet',
};

export const Translation = {
  a11yAverage: {
    namespace: TranslationNamespace,
    key: 'ratings_read_a11y_avarage_rating',
    default: defaultLabels.a11yAverage,
  },
  a11yOutOf: {
    namespace: TranslationNamespace,
    key: 'ratings_read_a11y_out_of',
    default: defaultLabels.a11yOutOf,
  },
  a11yBasedOn: {
    namespace: TranslationNamespace,
    key: 'ratings_read_a11y_based_on',
    default: defaultLabels.a11yBasedOn,
  },
  a11yVotes: {
    namespace: TranslationNamespace,
    key: 'ratings_read_a11y_votes',
    default: defaultLabels.a11yVotes,
  },
  a11yNoVotes: {
    namespace: TranslationNamespace,
    key: 'ratings_read_a11y_no_ratings_label',
    default: defaultLabels.a11yNoVotes,
  },
};
